export function releaseStaleModalBodyLock() {
  if (typeof document === "undefined") return;

  window.setTimeout(() => {
    const hasOpenModal = document.querySelector(
      '[data-app-modal-content="true"][data-state="open"]',
    );

    if (!hasOpenModal && document.body.style.pointerEvents === "none") {
      document.body.style.removeProperty("pointer-events");
    }
  }, 0);
}